<!-- 宏观概览 -->
<template>
  <div>
    <H3Title :title="boxTitle"></H3Title>

    <div style="display:flex;margin-top: 24px;">
      <div style="width: 50%;min-width: 240px;">
        <ChartTpl
          :v-if="HGOverview.remark"
          :elementId='"arcgapEle1"'
          :enableResize='true'
          :width='"100%"'
          :height='"240px"'
          :option="arcgapOption"
          :originData='arcgapData'
        ></ChartTpl>
      </div>
      <div class="txt" v-if="HGTodayData.SH_PE">
        <div class="txt-top">
          <p class="txt-top-title">市场估值: </p>
          <p>上证PE: <span>{{SH_PEvalue}}</span></p>
          <p>上证PB: <span>{{SH_PBvalue}}</span></p>
          <p>两市总市值: <span>{{dualMarketValue}}</span>{{dualMarketValueUnit}}</p>
          <p>两市成交额: <span>{{dualTurnover}}</span>{{dualTurnoverUnit}}</p>
        </div>
        <div class="txt-bottom">
          <p class="txt-bottom-title">货币流动性：</p>
          <p>M1: <span>{{M1percentile}}</span> <div :ltip="m1Tip" class="tips"></div></p>
          <p>DR007: <span>{{DR007percentile}}</span> <div :ltip="dr007Tip" class="tips"></div></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import H3Title from "@/components/H3Title";
import ChartTpl from "@/components/ChartTpl";

export default {
  name: "HGOverview",
  components: {
    H3Title,
    ChartTpl
  },
  props: {
    today: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "宏观概览"
    },
    HGTodayData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    HGOverview: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    m1Tip(){
      return '数据更新时间：'+this.HGTodayData.M1.date
    },
    dr007Tip(){
      return '数据更新时间：'+this.HGTodayData.DR007.date
    },
    boxTitle() {
      return this.title;
      // return this.title +' '+ this.today.substr(0, 4) +'-'+this.today.substr(4, 2)+'-'+this.today.substr(6, 2);
    },
    SH_PEvalue() {
      return this.HGTodayData.SH_PE&& this.$util.number.getShowValue(this.HGTodayData.SH_PE.realValue, 2);
    },
    SH_PBvalue() {
      return this.$util.number.getShowValue(this.HGTodayData.SH_PB.realValue, 2)
    },
    dualMarketValue() {
      return this.$util.number.getUnitNumber(this.$util.number.getShowValue(this.HGTodayData.dualMarketValue.realValue),2,0);
    },
    dualMarketValueUnit() {
      return this.$util.number.getUnitNumber(this.HGTodayData.dualMarketValue.realValue,2,2);
    },
    dualTurnover() {
      return this.$util.number.getUnitNumber(this.$util.number.getShowValue(this.HGTodayData.dualTurnover.realValue),2,0);
    },
    dualTurnoverUnit() {
      return this.$util.number.getUnitNumber(this.HGTodayData.dualTurnover.realValue,2,2);
    },
    M1percentile() {
      let v = this.$util.number.getShowValue(this.HGTodayData.M1.realValue, 2);
      return v === '--' ? v : v+'%'
    },
    DR007percentile() {
      let v = this.$util.number.getShowValue(this.HGTodayData.DR007.realValue, 2);
      return v === '--' ? v : v+'%'
    }
  },
  data() {
    return {
      arcgapData: [],
      arcgapOption: {}
    };
  },
  mounted(){
    LTip.width = 160;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();
  },
  updated(){
    LTip.width = 160;
    LTip.reBind();
  },
  watch: {
    HGOverview: {
      handler(newvalue, oldvalue){
        this.initArcgap();
      }
    }
  },
  methods: {
    initArcgap() {
      let data = this.HGOverview.remark.toFixed(0)
      this.arcgapOption = this.$chartConfigs.hgArc();
      this.arcgapOption.data[0] = {
        originData: {
          value: data
        }
      }
      this.arcgapData = this.arcgapOption.data
    }
  }
};
</script>

<style lang="scss" scoped>
.txt {
  font-size: 13px;
  position: relative;
  margin-top: 10px;
  min-width: 150px;
  flex: 1;
  margin-left: 4%;
  p {
    line-height: 25px;
    display:inline-block;
  }
  span {
    color: #fd4332;
    margin-left: 6px;
  }
  &-top {
    margin-bottom: 20px;
    &-title {
      font-size: 15px;
    }
  }
  &-bottom-title {
    font-size: 15px;
  }
}

.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  margin-left:10px;
  display:inline-block;
  width:28px;
  height: 17px;
  line-height: 22px;
  vertical-align: middle;
  margin-bottom: 6px;
}
</style>
